module.exports = __webpack_public_path__ + "static/media/kids_08.bc41b1e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_08.jpg
// module id = 5864
// module chunks = 0